/**
 * Depends on jquery validation js and marb-web.js
 * (to be used in mobile version refactor is needed)
 */

try {
	Marb.extend({
		Geo : (function() {
			var _count = 1;
            var _addressAutocomplete;
            var _place;
            var _requiredPlaceComponents = {
                street_number: 'short_name',
                route: 'long_name'
            };

			/**
			 * Validates an automcomplete component
			 * @param txtFieldId input field to validate
			 * @param hidden field that contains the real value
			 * @param errormsg message to be displayed on error
			 */
			var validateAutocomplete = function(txtFieldId, hiddenFieldId, errormsg) {
				$("#" + txtFieldId).rules("add", { autocomplete: { hidden: hiddenFieldId } });
				$.validator.addMethod("autocomplete",function(value,element,options){
					var elem = $("#"+ options.hidden);
					if( elem && elem.val()){
						return elem.val().length != 0;
					}
					return true;
				},errormsg);
			};
			
			var _location;
			
			var setCurrentLocation = function(currentLoc){
				_location = currentLoc;
			};
			
			var getCurrentLocation = function(){
				return _location;
			}
			
			var setLocation = function(locId, callback){
				callback = callback || function(){};
				if( !locId || locId == "" ){
					debug.warn('Called setLocation without any "locId" argument');
					return;
				}
				$.post('/geo/set',{'locId': locId},function(data){
					if( data && data.success){
						if(data.data.redirectUrl) {
							document.location = data.data.redirectUrl;
						}
						else {
							callback(new M.Geo.Location(
							{
								code: locId,
								name: data.data.location
							}));
						}
					}else{
						debug.error('Could not set location (' + locId + ')');
					}
				});
			};

			/**
			 * Remotely loads location data for a given location Id, on an Origin
			 * into a targetId (SELECT element).
			 */
			var loadCombo = function(locId, originId, targetId, params){
				if( locId == "" ){
					return;
				}
				loadData($(originId).val(), params.skipLocs, function(data) {
					var mainOption ='<option value="">' + $.i18n.prop('p.generic.chooseOne') + '</option>';
					var html = mainOption;

					$.each(data, function(key, val) {
						html += '<option value="' + key + '">' + val + '</option>';
					});
					$(targetId).html(html);
					if( params ){
						if(params.clearId ){
							$.each(params.clearId, function(key, val){
								$(val).html(mainOption);
							});
						}
						if( params.onFinish ){
							params.onFinish(data);
						}
					}
				});
			};
			
			/**
			 * Gets the remote data, children of a given location
			 */
			var loadData = function(locId, skipLocs, callback){
				var doSkip = (typeof skipLocs !== 'undefined') ? skipLocs : true;
				$.getJSON('/geo/locs', {'locId' : locId, 'skip': doSkip}, callback);
			}

			/**
			 * Creates the widget to work with a linked-combo
			 * selector for country, state, city and urban region
			 * (i.e. 4 combo selectors)
			 */
			var setSingleCitySelector = function(data){
				var buttonId = data.buttonId ? '#' + data.buttonId : '#-_-null';
				var onAccept = data.onAccept || function(){};
				var onChange = data.onChange || function(){};
				var countryComboId = '#'+data.countryComboId;
				var stateComboId = '#'+data.stateComboId;
				var cityComboId = '#'+data.cityComboId;
				var urbanComboId;
				var urbanContainerId = data.urbanContainerId ? '#' + data.urbanContainerId : null;
				var countryChangeClear = cityComboId;
				var stateChangeClear = [];
				var givenLocationCode = data.givenLocationCode? data.givenLocationCode.split('.') : [];
				if( data.urbanComboId ){
					urbanComboId = '#'+data.urbanComboId;
					countryChangeClear = [cityComboId, urbanComboId];
					stateChangeClear = [urbanComboId];
				}
				var acceptBtn = $(buttonId);
				$(countryComboId).focus(function(){
					var u = 3*12;
				});
				$(countryComboId).change(function(){
					loadCombo($(this).val(), countryComboId, stateComboId, {
						skipLocs: false,
						clearId: countryChangeClear, 
						onFinish: function(newData){
							$(stateComboId).focus();
							onChange('country', newData);
						}
					});
					acceptBtn.attr('disabled','disabled');
				});
				
				$(stateComboId).change(function(){
					loadCombo($(this).val(), stateComboId, cityComboId, {
						skipLocs: false,
						clearId: stateChangeClear,
						onFinish: function(newData){
							$(cityComboId).focus();
							onChange('state', newData);
						}
					});
					acceptBtn.attr('disabled','disabled');
				});
				
				if(	data.urbanComboId ){
					$(cityComboId).change(function(){
						loadCombo($(this).val(), cityComboId, urbanComboId, {
							skipLocs: false,
							onFinish: function(data){
								if( urbanContainerId ){
									if( $.isEmptyObject(data) ){
										$(urbanContainerId).hide();
										acceptBtn.removeAttr('disabled');
									}else{
										$(urbanComboId).focus();
										$(urbanContainerId).show();
										acceptBtn.attr('disabled','disabled');
									}
								}
								onChange('city', data);
							}
						});
					});
					$(urbanComboId).change(function(){
						if($(this).val().length > 0 ){
							acceptBtn.removeAttr('disabled');
						}else{
							acceptBtn.attr('disabled','disabled');
						}
						onChange('urban', {});
					});
				}else{
					$(cityComboId).change(function(){
						if( $(this).val().length > 0 ){
							acceptBtn.removeAttr('disabled');
						}else{
							acceptBtn.attr('disabled','disabled');
						}
						onChange('city',{});
					});
				}
				
				acceptBtn.attr('disabled','disabled');
				acceptBtn.click(function(){
					var citySelected = $(cityComboId).val().length > 0;
					var urbanExists =  citySelected &&
					   $(urbanComboId +' option').length > 1;
					var value = urbanExists ? $(urbanComboId).val() : $(cityComboId).val();
					if( value.length > 0 ){
						onAccept(value);
						$.modal.close();
					}
				});

				if(givenLocationCode.length > 0) {
					var locIdVal = givenLocationCode[0];
					$(countryComboId).val(locIdVal);
					loadCombo(locIdVal, countryComboId, stateComboId, {
						skipLocs: false,
						clearId: countryChangeClear, 
						onFinish: function(newData){
							$(stateComboId).focus();
							onChange('country', newData);
							if(givenLocationCode[1]) {
								var locIdVal = [givenLocationCode[0],givenLocationCode[1]].join('.');
								$(stateComboId).val(locIdVal);
								loadCombo(locIdVal, stateComboId, cityComboId, {
									skipLocs: false,
									clearId: stateChangeClear,
									onFinish: function(newData){
										$(cityComboId).focus();
										onChange('state', newData);
										if(givenLocationCode[2]) {
											var locIdVal = [givenLocationCode[0],givenLocationCode[1],givenLocationCode[2]].join('.');
											$(cityComboId).val(locIdVal);
											loadCombo(locIdVal, cityComboId, urbanComboId, {
												skipLocs: false,
												onFinish: function(data){
													if( urbanContainerId ){
														if( $.isEmptyObject(data) ){
															$(urbanContainerId).hide();
															acceptBtn.removeAttr('disabled');
														}else{
															$(urbanComboId).focus();
															$(urbanContainerId).show();
															acceptBtn.attr('disabled','disabled');
														}
													}
													onChange('city', data);
													if(givenLocationCode[3]) {
														$(urbanComboId).val([givenLocationCode[0],givenLocationCode[1],givenLocationCode[2],givenLocationCode[3]].join('.'));
														acceptBtn.removeAttr('disabled');
													}
												}
											});
										}
									}
								});
							}
							acceptBtn.attr('disabled','disabled');
						}
					});
					acceptBtn.attr('disabled','disabled');
				}
			};

			var setCityAutocomplete = function(data){
				Marb.Page.setAutocomplete('/geo/search/', data);
			};
			
			var setCityAutocompleteForAdmin = function(data, onSelect, dataTable){
				Marb.Page.setAutocomplete('/geo/search/admin/', data, onSelect, dataTable);
			};

			var MultiUrbanSelector = function(data){
				this.countryComboId = '#' + data.countryComboId;
				this.stateComboId = '#' + data.stateComboId;
				this.cityComboId = data.cityComboId ? '#' + data.cityComboId : null;
				this.urbanContainerId = '#' + data.urbanContainerId;
				this.selectedUrbansContainerId = '#' + data.selectedUrbansContainerId;
				this.selectedUrbansValueId = '#' + data.selectedUrbansHiddenId;
				this.selectAllUrbansClass = '.' + data.selectAllUrbansBtnClass;
				this.selectNoUrbansId = '#' + data.selectNoUrbansBtnId;
				this.selectChooseId = '#' + data.selectChooseBtnId;
				this.urbanSelectedTemplateId = '#' + data.urbanSelectedTemplateId;
				this.urbanContainerTemplateId = '#' + data.urbanContainerTemplateId;
				this.onUrbanSelected = data.onUrbanSelected ? data.onUrbanSelected : function(){};
				this.onUrbanRemoved = data.onUrbanRemoved ? data.onUrbanRemoved : function(){};
				this.onCitySelected = data.onCitySelected ? data.onCitySelected : function(){};
				this.onStateSelected = data.onStateSelected ? data.onStateSelected : function(){};
				this.onCountrySelected = data.onCountrySelected ? data.onCountrySelected : function(){};
				this.idx = _count++;
				this.tiersToShow = data.cityComboId ? 4 : 3;
				
				this.init = function(){
					var obj = this;
					//init the country combo
					$(this.countryComboId).change(function(){
						loadCombo($(this).val(), obj.countryComboId, obj.stateComboId, 
							{skipLocs: true,
							onFinish: 
								function(){
									$(obj.urbanDataContainerId).html('');
									obj.onCountrySelected();
								},
								clearIds: [obj.cityComboId]
							}
						);
					});
					
					//init the state
					if( this.cityComboId != null ){
						$(this.stateComboId).change(function(){
							loadCombo($(this).val(), obj.stateComboId, obj.cityComboId,
								{skipLocs: false,
								 onFinish:
									function(){
										$(obj.urbanDataContainerId).html('');
										obj.onStateSelected();
									}
								}
							);
						});
					}else{
						this.cityComboId = this.stateComboId;
					}
					
					//init the city combo
					$(this.cityComboId).change(function(){
						if( $(this).val().length > 0 ){
							//check if all of this city is already selected
							var cityIsSelected = obj.isLocationSelected($(this).val());
							obj.setCitySelectedStatus(cityIsSelected);
							
							var code = $(this).val();
							var name = $(this).children("option").filter(":selected").text();
							//get cities
							$.getJSON('/geo/locs', {locId: code}, function(data){
								var container = $(obj.urbanDataContainerId);
								container.html('');
								var count = 0;
								$.each(data, function(key, val){
									obj.addUrbanRegion(key, val);
									count++;
								});
								if( count == 0){
									var msg = $.i18n.prop('p.generic.location.urban.nomatches');
									$(obj.urbanMsgContainerId).html('<span>'+msg+'</span>');
									$(obj.urbanMsgContainerId).show();
									obj.setNoUrbansAvailableStatus();
								}
								obj.onCitySelected(code, name);
								M.Page.scrollable(obj.urbanContainerId, 'update');
							});
						}
					});
					
					$(this.selectAllUrbansClass).click(function(){
						obj.setCitySelectedStatus(true);
						var combo = $(obj.cityComboId + ' option:selected');
						obj.selectCity(combo.val(), combo.text());
					});

					$(this.selectNoUrbansId).click(function(){
						obj.setCitySelectedStatus(false);
						//remove city from selection
						var code = $(obj.cityComboId).val();
						$(obj.selectedUrbansContainerId).find('[id ^="' + obj.idx + '-selcity-'+ code + '"]').click()
						//size changes considerably. re-calculate
						//var container = $(obj.urbanContainerId).parents('.simplemodal-container');
						//container.css('width','');
						//container.css('height','');
						//$.modal.setContainerDimensions();
						M.Page.scrollable(obj.urbanContainerId, 'update');
					});
					
					//create the comments container
					
					$(this.urbanContainerId).append('<div class="msgContainer"></div>');
					$(this.urbanContainerId).append('<div class="urbanContainer"></div>');
					this.urbanMsgContainerId = this.urbanContainerId + ' .msgContainer';
					this.urbanDataContainerId = this.urbanContainerId + ' .urbanContainer';
					M.Page.scrollables(this.urbanContainerId);
					this.setCitySelectedStatus(false);
					if( $(this.cityComboId).val() <=0 ){
						$(this.selectAllUrbansClass).hide();
					}
					$(this.selectedUrbansValueId).val('');
					
				//end of init
				};

				//returns if a given location was already selected
				this.isLocationSelected = function(code){
					return $('[id="'+ this.idx + '-selcity-' + code + '"]').length > 0;
				};
				
				this.setNoUrbansAvailableStatus = function(){
					$(this.selectAllUrbansClass).show();
					$(this.selectChooseId).hide();
				};
				
				//hides and shows elements based on a given city being fully selected (or not)
				this.setCitySelectedStatus = function(cityIsSelected){
					$(this.selectChooseId).show();
					if( cityIsSelected ){
						$(this.urbanDataContainerId).children(':checkbox').each(function(){
							$(this)[0].checked = true;
						});
						
						$(this.urbanDataContainerId).hide();
						$(this.urbanMsgContainerId).html('<span>'+
								$.i18n.prop('p.generic.location.cityselected')+'</span>');
						$(this.urbanMsgContainerId).show();
						$(this.selectAllUrbansClass).hide();
						$(this.selectNoUrbansId).show();
					}else{
						$(this.urbanDataContainerId).children(':checkbox').each(function(){
							$(this)[0].checked = false;
						});
						
						$(this.urbanMsgContainerId).hide();
						$(this.urbanDataContainerId).show();
						$(this.selectAllUrbansClass).show();
						$(this.selectNoUrbansId).hide();
					}
				};
				
				//selects a full city
				this.selectCity = function(code, name){
					var add = ! this.isLocationSelected(code);
					if( add ){
						var obj = this;
						if( code && code != "" ){
							this.addCoverageUrbanValue(code, name, function(){
								$(this).remove();
								obj.removeCoverageUrbanValue(code);
							});
							//remove urbans from this state already selected
							$(obj.selectedUrbansContainerId).find('[id ^="' + obj.idx + '-selcity-'+ code + '."]').each(
								function(){
									$(this).click();
								}
							);
						}
					}
				};
				
				//adds the given Urban to the hidden value list
				this.addCoverageUrbanValue = function(code, name, onclick){
					var addedUrban = $(this.urbanSelectedTemplateId).clone();
					addedUrban.attr('id', this.idx + '-selcity-' + code)
							.attr('urbancode', code)
							.click(onclick);
					addedUrban.html(name);
					
					$(this.selectedUrbansContainerId).append(addedUrban);
					var hiddenValue = $(this.selectedUrbansValueId).val();
					if( hiddenValue == "" ){
						$(this.selectedUrbansValueId).val(code);
					}else{
						$(this.selectedUrbansValueId).val(code + ',' + hiddenValue);
					}
					this.onUrbanSelected(code, name);
				};

				//removes an Urban from the selected list
				this.removeCoverageUrbanValue = function(code){
					var pattern = new RegExp(',' +code + '$|' + code + ',|^' + code + '$');
					var textData = $(this.selectedUrbansValueId).val();
					textData = textData.replace(pattern, '');
					$(this.selectedUrbansValueId).val(textData);
					this.onUrbanRemoved(code);
				};
				
				//selects an urban region
				this.selectUrban = function(code, name){
					var add =  ! this.isLocationSelected(code);
					if( add ){
						//selected urban
						if(! name ){
							var urban = $('[id="' + this.idx + '-cty-' + code + '"]');
							var name = urban.attr('urbanname');
							var check = urban.find(':checkbox');
							check[0].checked = true;
						}
						var obj = this;
						this.addCoverageUrbanValue(code, name, function(){
							obj.selectUrban(code);
						});
					}else{
						//deselected urban
						var selectedUrban = $('[id="' + this.idx + '-selcity-'+code +'"]');
						if( selectedUrban ){
							selectedUrban.remove();
							var urban = $('[id="' + this.idx + '-cty-'+code+'"]');
							if( urban.length > 0 ){
								var check = urban.find(':checkbox');
								check[0].checked = false;
							}
							this.removeCoverageUrbanValue(code);
						}
					}
				};
				
				//adds the urban region html to the selection list
				this.addUrbanRegion = function(key, val){
					var container = $(this.urbanDataContainerId);
					var checked = this.isLocationSelected(key);
					var urbanCont = $(this.urbanContainerTemplateId).clone();
					urbanCont
								.attr('id', this.idx + '-cty-'+key)
								.attr('urbancode', key)
								.attr('urbanname', val);
					var urbanCheck = urbanCont.find(":checkbox");
					urbanCheck
								.attr('id', this.idx + '-chk-' + key);
					urbanCheck[0].checked = checked;
					var urbanValue = urbanCont.find('.geo-urban-text');
					urbanValue.html(val);
					urbanCont.appendTo(container);
					var obj = this;
					urbanCont.click(function(event){
						obj.selectUrban($(this).attr('urbancode'));
					});
				};
				
				this.updateStatus = function(){
					var cityCombo = $(this.cityComboId);
					var cityIsSelected = this.isLocationSelected(cityCombo.val());
					this.setCitySelectedStatus(cityIsSelected);
				};
				
				//end of class
			};
			
			var Location = function(param){
				this.encodedValue;
				this.country;
				this.state;
				this.city;
				this.urbanRegion;
				this.name;
				this.exactLocation;
				this.preferredLocation;
				
				this.encodedValue = param.code;
				this.name = param.name;
					
				var vals = this.encodedValue.split('.');
				var len = vals.length;
				switch(len){
					case 4:
						this.urbanRegion = vals[3];
					case 3:
						this.city = vals[2];
					case 2:
						this.state = vals[1];
					case 1:
						this.country = vals[0];
				}
				
				this.isSameCountry = function(other){
					return this.country == other.country;
				};
				
			};

			var setGoogleAddressAutocomplete = function(_params){
				var obj = this;
				var params = _params;

				var restrictions = {country: params.country};
				_addressAutocomplete = new google.maps.places.Autocomplete(
					($(params.address_selector)[0]),
					{types: ['address'], componentRestrictions: restrictions});

				// When the user selects an address from the dropdown
				_addressAutocomplete.addListener('place_changed', function(){ obj.fillInAddress() });
				
                this.fillInAddress = function() {

                    _place = _addressAutocomplete.getPlace();

                    if(obj.isValidAddress()) {
                    	var place = obj.normalizeGooglePlace(_place);
                        $(params.latitude_selector).val(place.latitude);
                        $(params.longitude_selector).val(place.longitude);
                        if( params.zip_selector && $(params.zip_selector).length > 0 ){
                        	$(params.zip_selector).val(place.zip);
                        }
                        obj.addLocationValue(place);
                        if( params.callback ){
                        	params.callback(place);
                        }
                    }else {
                        $(params.latitude_selector).val('0');
                        $(params.longitude_selector).val('0');
                        $(params.address_selector).val('');
                        $(params.zip_selector).val('');
                        if( params.onInvalidAddress ){
                    		params.onInvalidAddress();
                    	}
                    }
                };

				this.isValidAddress = function(){
                    var requiredPlaceComponentsLength=0;
                    for (var i in _requiredPlaceComponents) if (_requiredPlaceComponents.hasOwnProperty(i)) requiredPlaceComponentsLength++;

                    var requiredElementsInPlace = 0;

                    if(_place && _place.address_components) {
                        for (var i = 0; i < _place.address_components.length; i++) {
                            var addressType = _place.address_components[i].types[0];
                            if (_requiredPlaceComponents[addressType]) {
                                requiredElementsInPlace++;
                            }
                        }
                        return requiredElementsInPlace == requiredPlaceComponentsLength;
                    }else{
                        return false;
                    }
                };

                this.addLocationValue = function(place) {
                    var urlSearchLocation = "/geo/search";
                    var sanitizedTerm = place.neighbourhood.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                    var sanitizedState = place.state.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                    var geoParams = {
                    		term: sanitizedTerm, 
                    		filter: 'city+', 
                    		state: sanitizedState,
                			lat: place.latitude,
                			lng: place.longitude
                    }
                    if( place.city && place.city.length > 0 ){
                    	geoParams.city = place.city;
                    }
                    $.get(urlSearchLocation, geoParams, function(response){
                            if(response.success) {
                            	if( response.data.length > 0 ){
                            		$(params.location_selector).val(response.data[0].id);
                            		$(params.locationtxt_selector).val(response.data[0].label);
                            	}else{
                            		if( params.onLocationSearchError){
                            			params.onLocationSearchError(sanitizedTerm + ', ' + sanitizedState);
                            		}
                            	}
                            }
                        }
                    );
                };
                
                this.normalizeGooglePlace = function(input){
                	function typeMatch(types, target){
                		for(var i=0; i < types.length; i++){
                			if( types[i] == target){
                				return true;
                			}
                		}
                		return false;
                	};
                	function getTypeValue(acs, target){
                		for(var i=0; i < acs.length; i++){
                			var ac = acs[i];
                			if( typeMatch(ac.types, target) ){
                				return ac.long_name;
                			}
                    	}
                		return '';
                	};
                	var ac = input.address_components;
                	
                	var place = {};
                	place.streetName = getTypeValue(ac, 'route');
                	place.streetNumber = getTypeValue(ac, 'street_number');
                	place.zip = getTypeValue(ac, 'postal_code').replace(/[ -]/g, '');
                	var vicinity = getTypeValue(ac, 'sublocality_level_1');
                	var city = getTypeValue(ac, 'locality') || '';
                    if( ! vicinity ){
                    	vicinity = getTypeValue(ac, 'neighborhood');
                    }
                    if( ! vicinity ){
                    	vicinity = getTypeValue(ac, 'locality');
                    }
                    if (!vicinity){
                        vicinity = getTypeValue(ac, 'administrative_area_level_1');
                    }
                    if( !vicinity ){
                    	vicinity = input.vicinity;
                    }
                	place.neighbourhood = vicinity;
                	place.city = city;
                	place.state = getTypeValue(ac, 'administrative_area_level_1');
                	if( typeof input.geometry.location.lat == "function" ){
                		place.latitude = input.geometry.location.lat().toFixed(8);
                		place.longitude = input.geometry.location.lng().toFixed(8);
                	}else{
                		place.latitude = input.geometry.location.lat.toFixed(8);
                		place.longitude = input.geometry.location.lng.toFixed(8);
                	}
                	
                	return place;
                };

			};
			
			return {
				validateAutocomplete : validateAutocomplete,
				setLocation : setLocation,
				setSingleCitySelector : setSingleCitySelector,
				setCityAutocomplete : setCityAutocomplete,
				setCityAutocompleteForAdmin : setCityAutocompleteForAdmin,
				MultiUrbanSelector : MultiUrbanSelector,
				setCurrentLocation: setCurrentLocation,
				getCurrentLocation: getCurrentLocation,
				Location: Location,
				setGoogleAddressAutocomplete: setGoogleAddressAutocomplete
			};
		})()
	});
}
catch (e) {
	debug.error("Marb namespace not present", e);
}
